import(/* webpackMode: "eager" */ "/codebuild/output/src2919109647/src/apps/wrap.gifts/node_modules/next/dist/client/link.js");
